module.exports = __webpack_public_path__ + "static/TangleTower5-fe409a546901461fcc0134aee6c79788.webp";